import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl, useAppRoutes } from '@webapp/hooks'
import messages from './messages'

export const ManagePaymentAccountsPageTabs = {
  ACCOUNTS: 'accounts',
  CREDIT_CARDS: 'creditcards',
} as const

export interface ManagePaymentAccountsPageParams {
  status: string
}

const ManagePaymentAccountsViewChunk = lazy(() =>
  import('../feature-sets/ManagePaymentAccountsView').then(
    ({ ManagePaymentAccountsView }) => ({
      default: ManagePaymentAccountsView,
    })
  )
)

export const ManagePaymentAccountsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.managePaymentAccountsPageTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          name: intl.formatMessage(messages.managePaymentAccountsPageTitle),
        },
      ]}
    >
      <ManagePaymentAccountsViewChunk />
    </Page>
  )
}
